// this delay is to allow images to load and resize

export function callAFewMoreTimes(func) {
  setTimeout(func, 100)
  setTimeout(func, 150)
  setTimeout(func, 200)
}
